
import { watchEffect, ref } from "vue";
import { Options } from "vue-class-component";
import Base from "../../base/Base.vue";
@Options({
  props: ["data"]
})
export default class Topics extends Base {
  topics = ref([]);
  public data = {
    topics: this.topics
  } as any;
  paymentOptions = [
    { name: "Science", value: "science" },
    { name: "Art", value: "art" }
  ];

  created() {
    watchEffect(() => {
      const data = {
        topics: this.topics
      };
      this.$emit("update:data", data);
    });
  }
}
